export default __webpack_public_path__ + "static/MineralSwimV2_Carton+ControlUnit+PURIFIER-192b142638f48ea2a37411d79ea38b55.png";